import React from "react";
import Flickity from "react-flickity-component";
import SliderStyle from "../../components/styles/slider";

export const SliderInstagramMobile = ({ children }) => {
  const flickityOptions = {
    contain: "true",
    prevNextButtons: false,
    cellAlign: "left",
    freeScroll: "true",
    pageDots: false
  };
  return (
    <div className="carousel-wrapper-ig-mobile">
      <div className="carousel-container-ig-mobile">
        <Flickity
          options={flickityOptions}
          className={"carousel"}
          elementType={"div"}
        >
          {children}
        </Flickity>
      </div>
      <SliderStyle />
      <style jsx global>
        {`
          .carousel-wrapper-ig-mobile {
            max-width: 940px;
            width: 100%;
            align-self: center;
          }
          .carousel-container-ig-mobile {
            margin-left: 12px;
          }
        `}
      </style>
    </div>
  );
};
